import templateUrl from "emun.cart/cart-pricelist-dropdown-menu.htm";
import controller from "emun.cart/cart-pricelist-dropdown-menu.controller";

export default {
  bindings: {
    toggleClasses: "@",
    dropdownMenuClasses: "@",
    badgeClasses: "@",
    icon: "@",
    size: "@",
    hideBadge: "<?",
    query: "=?",
    virtualCallId: "=?",
    onSelected: "&",
  },
  transclude: {
    dropdownToggle: "?dropdownToggle",
    // menu: "?menu",
    // tabset: "?tabset",
    // repeater: "?repeater"
  },
  controller,
  templateUrl($element, $attrs) {
    if ($attrs.templateUrl) return $attrs.templateUrl;
    return templateUrl;
  },
};
